import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { FiBell } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import Tooltip from "../../ToolTip";
import { useSelector } from "react-redux";
import { hideAll } from "tippy.js";

const NotificationsMenu = () => {
  const DashboardSummary = useSelector((state) => state?.data?.Summary);
  const navigate = useNavigate();

  const hasNotifications =
    DashboardSummary?.AddressChangesCount +
      DashboardSummary?.LawyerRequestsCount +
      DashboardSummary?.StocksRequestsCount +
      DashboardSummary?.BankAccountChangesCount +
      // DashboardSummary?.ContactUsOpenCount +
      DashboardSummary?.MessageCount >
    0;
  return (
    <Menu as="div" className="relative inline-block">
      <Tooltip content="اعلانات">
        <Menu.Button
          aria-label="اعلانات"
          className="inline-flex py-2 justify-center w-full transform scale-125"
        >
          <FiBell
            className={`${
              hasNotifications
                ? "animate__animated animate__swing animate__infinite stroke-attention fill-attention animate__slow"
                : ""
            }`}
          />
        </Menu.Button>
      </Tooltip>
      <Transition
        afterLeave={() => hideAll()}
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute -left-12 transform w-64 mt-2 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg border dark:border-borderSolid">
          <div className="px-1 py-1 font-normal">
            <Menu.Item onClick={() => navigate("bank")}>
              {({ active }) => (
                <button
                  className={`${
                    active ? "bg-brand dark:bg-dark text-white" : "text-title"
                  } group flex dark:text-title rounded-md items-center w-full px-2 py-2 text-sm`}
                >
                  درخواست تغییر اطلاعات بانکی:
                  <span className="mr-1">
                    {DashboardSummary?.BankAccountChangesCount}
                  </span>
                </button>
              )}
            </Menu.Item>
            <Menu.Item onClick={() => navigate("address")}>
              {({ active }) => (
                <button
                  className={`${
                    active ? "bg-brand dark:bg-dark text-white" : "text-title"
                  } group flex dark:text-title rounded-md items-center w-full px-2 py-2 text-sm`}
                >
                  درخواست تغییر اطلاعات آدرس:
                  <span className="mr-1">
                    {DashboardSummary?.AddressChangesCount}
                  </span>
                </button>
              )}
            </Menu.Item>
            <Menu.Item onClick={() => navigate("stockrequests")}>
              {({ active }) => (
                <button
                  className={`${
                    active ? "bg-brand dark:bg-dark text-white" : "text-title"
                  } group flex dark:text-title rounded-md items-center w-full px-2 py-2 text-sm`}
                >
                  درخواست افزودن سهامدار
                  <span className="mr-1">
                    {DashboardSummary?.StocksRequestsCount}
                  </span>
                </button>
              )}
            </Menu.Item>
            <Menu.Item onClick={() => navigate("lawyerrequests")}>
              {({ active }) => (
                <button
                  className={`${
                    active ? "bg-brand dark:bg-dark text-white" : "text-title"
                  } group flex dark:text-title rounded-md items-center w-full px-2 py-2 text-sm`}
                >
                  درخواست نماینده:
                  <span className="mr-1">
                    {DashboardSummary?.LawyerRequestsCount}
                  </span>
                </button>
              )}
            </Menu.Item>
            <Menu.Item onClick={() => navigate("messageBetter")}>
              {({ active }) => (
                <button
                  onClick={() => navigate("messageBetter")}
                  className={`${
                    active ? "bg-brand dark:bg-dark text-white" : "text-title"
                  } group flex dark:text-title rounded-md items-center w-full px-2 py-2 text-sm`}
                >
                  پیام خوانده نشده:
                  <span className="mr-1">{DashboardSummary?.MessageCount}</span>
                </button>
              )}
            </Menu.Item>
            {/*<Menu.Item onClick={() => navigate("ticket")}>
              {({ active }) => (
                <button
                  onClick={() => navigate("ticket")}
                  className={`${
                    active ? "bg-brand dark:bg-dark text-white" : "text-title"
                  } group flex dark:text-title rounded-md items-center w-full px-2 py-2 text-sm`}
                >
                  تیکت پشتیبانی خوانده نشده:
                  <span className="mr-1">
                    {DashboardSummary?.ContactUsOpenCount}
                  </span>
                </button>
              )}
            </Menu.Item>*/}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default NotificationsMenu;
